module.exports = __webpack_public_path__ + "static/media/partner-icon-blockfrost-white.62d0c619.svg";